import { getAudioListByName } from "@/api/audioSet";
import { resCategoryTree } from "@/api/rescategory";
import { Confirm } from "@/components/Confirm";
import moment from "moment";
export default {
  data() {
    // 校验输入字数的最大长度
    var maxLength = (rule, value, callback, length) => {
      if (value.length > length) {
        callback(new Error(`最多输入${length}个字`));
      } else {
        callback();
      }
    };
    return {
      audioSetData: [],
      videoCategoryData: [],
      lecturerData: [],
      publicData: [],
      videoForm: {
        audioLink: "",
        audioSetId: "",
        audioName: "",
        audioLength: 0,
        categoryId: "",
        audioSource: "",
        expireTime: "",
        coverUrl: "",
        audios: [],
        covers: []
      },
      rules: {
        audioLink: [
          {
            required: true,
            message: "请选择音频内容",
            trigger: "change"
          }
        ],
        audioName: [
          {
            required: true,
            message: "请输入音频名称",
            trigger: ["change", "blur"]
          },
          {
            validator: (rule, value, callback) => {
              maxLength(rule, value, callback, 50);
            },
            trigger: "blur"
          }
        ],
        categoryId: [
          {
            required: true,
            message: "请选择音频分类",
            trigger: ["change", "blur"]
          }
        ],
        audioSource: [
          {
            required: true,
            message: "请输入音频来源",
            trigger: ["change", "blur"]
          }
        ],
        expireTime: [
          {
            required: true,
            message: "请选择有效期",
            trigger: ["change", "blur"]
          }
        ],
        coverUrl: [
          {
            required: true,
            message: "请上传音频封面",
            trigger: "change"
          }
        ]
      },
      showProgress: false,
      progress: {
        audioProgress: 0
      },
      expireTimeOption: {
        disabledDate(date) {
          return (
            date.getTime() < new Date(moment().format("YYYY-MM:DD")).getTime()
          );
        }
      }
    };
  },
  created() {
    // 获取视频分类数据
    resCategoryTree().then(res => {
      if (!res || res.code != 0) return;
      this.videoCategoryData = res.data;
    });
  },
  watch: {
    "videoForm.audios": {
      handler(val) {
        if (val.length > 0) {
          this.videoForm.audioLink = val[0].url;
        } else {
          this.videoForm.audioLink = "";
          this.$forceUpdate();
        }
      }
    },
    "videoForm.covers": {
      handler(val) {
        if (val.length > 0) {
          this.videoForm.coverUrl = val[0].url;
        } else {
          this.videoForm.coverUrl = "";
        }
      }
    }
  },
  methods: {
    // 重置表单数据
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.$refs["videoForm"].resetFields();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 音频上传进度
    audioProgress(p) {
      this.showProgress = true;
      this.progress.audioProgress = p;
      if (p >= 100) {
        this.showProgress = false;
        this.progress.audioProgress = 0;
      }
    },
    // 搜索视频集
    searchAudioSet(query) {
      getAudioListByName({ audioSetName: query }).then(res => {
        if (!res || res.code != 0) return;
        this.audioSetData = res.data.records;
      });
    },
    deleteAudio() {
      this.videoForm.audios = [];
      this.videoForm.audioLength = 0;
    },
    deleteCover() {
      this.videoForm.covers = [];
    },
    audioDuration(t) {
      this.videoForm.audioLength = t;
    }
  }
};
